import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import headerLogo from "assets/images/shoe_logo.png";
import * as styles from "layout/LayoutStyles";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "store/authReducer";
import { resetMenu } from "store/menuReducer";
import { handleOpen } from "store/menuReducer";
import ButtonLogOut from "components/Buttons/ButtonLogOut";
import { Menu } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const Header = () => {
  const { isLoggedIn } = useSelector((storeState) => storeState.auth);
  const { menuOpen } = useSelector((storeState) => storeState.menu);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <Grid item xs={12} md={3} lg={2} sx={styles.headerGridItem()}>
        {isLoggedIn && (
          <IconButton onClick={() => dispatch(handleOpen(!menuOpen))}>
            <Menu />
          </IconButton>
        )}
        <Box
          component="img"
          sx={{ height: "50%", marginLeft: 2 }}
          src={headerLogo}
          alt="Xcelvations Logo"
        />
      </Grid>
      <Grid container item xs={12} md={9} lg={10} sx={styles.headerGridItem()}>
        <Box sx={{ display: "flex", flexGrow: 1, height: "60%" }}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexGrow: 1,
              justifyContent: "flex-end",
            }}
          >
            {isLoggedIn && (
              <ButtonLogOut
                handleClick={() => {
                  dispatch(resetMenu());

                  dispatch(logout());
                  navigate("/login");
                }}
              />
            )}
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default Header;
